import $ from 'jquery';
import globalSearchResultTemplate from './searchResult.hbs';
// import globalSearchEmptyTemplate from './globalSearchEmpty.hbs'
import CONSTANT from '../../common/js/_constant';

const globalSearchResult = {
    variables:{
        globalSearchButton:'.header__search',
        globalSearchWrapper:'.global__search--wrapper',
        globalSearchActive:'.global__search--wrapper--active',
        globalSearchForm:'.global__search--form',
        globalSearchInput:'.global__search--input',
        globalSearchResultList:'.global__search__result--list',
        globalSearchResultActive:'.search__active',
        globalSearchPopularWrapper:'.global__search--popular',
        globalSearchPopularTags:'.global__search__popular--item',
        searchData:[],
    },
    methods:{
        openSearch:function(el){
            const $this = el;
            const {globalSearchActive,globalSearchWrapper} = globalSearchResult.variables;
            $this.find(globalSearchWrapper).toggleClass(globalSearchActive.substr(1));
            $('.header__wrapper').toggleClass('search--active');  
            $this.focus();
        },
        openSearchBox:function(){
            const {CLICK} = CONSTANT.eventsListners;
            const {globalSearchButton,globalSearchWrapper} = globalSearchResult.variables;
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $this = this;
            $(globalSearchButton).on(CLICK,function(e){
                const $el = $(this);
                if ($(e.target).closest(globalSearchWrapper).length === 0) {
                $this.openSearch($el);
                $this.resetSearch();
                }
            }); 
            /* eslint-disable @typescript-eslint/no-this-alias */
        },
        searchSubmit:function(){
            const {CLICK} = CONSTANT.eventsListners;
            const {globalSearchForm} = globalSearchResult.variables;
            const $this = this;
            $('.search__submit').on(CLICK,function(e){
                $this.submitSearchInput($(globalSearchForm));
            })
        },
        submitSearchInput:function(el){
                const {variables} = globalSearchResult;
                const redirectPath = `${el.data('redirection-path')}.html`
                const searchData = el.serializeArray();
                const dataObject = searchData.reduce((accumulator, item) => {
                    accumulator[item.name] = item.value;
                    return accumulator;
                }, {});
                variables.searchData.length > 0 && variables.searchData.splice(0, variables.searchData.length);
                variables.searchData.push(dataObject);
                const searchText = variables.searchData[0]["searchText"];
                if(variables.searchData.length > 0 && searchText.length > 0){
                    window.location.href = `${redirectPath}?searchText=${encodeURIComponent(searchText)}&filter=${encodeURIComponent('AllResults')}`
                }
         },
         submitSearchVal:function(){
            const {SUBMIT} = CONSTANT.eventsListners;
            const {variables} = globalSearchResult;
            const {globalSearchForm} = variables;
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $this = this;
            $(globalSearchForm).on(SUBMIT,function(e){
                e.preventDefault();
                const $el = $(this);
                $this.submitSearchInput($el)
            });
            /* eslint-disable @typescript-eslint/no-this-alias */
         },
         searchInputResult:function(){
            const {INPUT} = CONSTANT.eventsListners;
            const {globalSearchInput,globalSearchResultList,globalSearchWrapper,globalSearchResultActive,globalSearchPopularWrapper} = globalSearchResult.variables;
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $this = this;
            const debouncedRequestCall = $this.debounce((inputVal) => {
                const requestPath = $(globalSearchInput).parent('form').data('search-path') || '/content/chli/in/en';
                const requestCount = $(globalSearchInput).parent('form').data('result-count') || 4;
                globalSearchResult.methods.requestCall(requestPath, requestCount, inputVal, globalSearchResultList,$this.searchResultList);
            }, 300);
            /* eslint-disable @typescript-eslint/no-this-alias */
            $(globalSearchInput).on(INPUT,function(e){
                const inputVal = $(this).val();
                if (inputVal.length >= 3) {
                    $(this).siblings('.global__search--result--wrapper').find(globalSearchResultList).addClass(globalSearchResultActive.substr(1));
                    debouncedRequestCall(inputVal);
                    $(globalSearchPopularWrapper).addClass('d-none');
                    $(globalSearchResultList).removeClass('d-none');
                    $(globalSearchWrapper).addClass('search--list--active');
                } else {
                    $(this).siblings(globalSearchResultList).removeClass(globalSearchResultActive.substr(1));
                        $(globalSearchPopularWrapper).removeClass('d-none');
                        $(globalSearchResultList).addClass('d-none');
                        $(globalSearchWrapper).removeClass('search--list--active');
                }
            });
         },
         requestCall:function(path,noOfResults,searchText,appendEl,sucFn=()=>{return}){
            $.ajax({
                url:`/bin/search?noOfSearchResult=${noOfResults}&path=${path}&searchText=${searchText}`,
                method:"POST",
            }).done(function(response){
                sucFn(response,appendEl)
                return response;
            }).fail(function(error){
                console.log("Error in request");
                return error;
            })
         },
         listener : function(e){
            let term = e.currentTarget.getElementsByClassName("global__search_result--link")[0].innerText.replace(/\n/g, '').trim();
            let eventObj = { searchTerm : term };
            let obj = globalSearchResult.methods.datalayerObj(eventObj,"Header Search");
            createDataLayer('enter_search_autosuggestions', obj);
        },
         searchResultList:function(response,appendEl){
            const {globalSearchForm} = globalSearchResult.variables;
            
            $(appendEl).find(".global__search__result--item").off('click', globalSearchResult.methods.listener);
            $(appendEl).html('');
            if(response?.length){
                if(response?.length){
                    $(appendEl).append(globalSearchResultTemplate({
                        items:response,
                        viewResultLink:$(globalSearchForm).data('redirection-path'),
                        viewResultLabel:$(globalSearchForm).data('view-result'),
                        noResultFoundText:$(globalSearchForm).data('no-result'),
                    }));
                }
            }else{
                $(appendEl).append(globalSearchResultTemplate({
                    item:[],
                    viewResultLink:$(globalSearchForm).data('redirection-path'),
                    ViewResultLabel:$(globalSearchForm).data('redirection-path'),
                    noResultFoundText:$(globalSearchForm).data('no-result'),
                }));
            }
            $(appendEl).find(".global__search__result--item").on('click', globalSearchResult.methods.listener);
         },
         debounce:function(func, delay) {
            let timeoutId;
            return function(...args) {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    func.apply(this, args);
                }, delay);
            };
        },
        closeOnEsc:function(){
            const {KEYDOWN} = CONSTANT.eventsListners;
            const {globalSearchButton,globalSearchActive,globalSearchWrapper} = globalSearchResult.variables;
            document.addEventListener(KEYDOWN, function(event) {
                if (event.key === 'Escape') {
                    $(globalSearchButton).find(globalSearchWrapper).removeClass(globalSearchActive.substr(1));
                    $('.header__wrapper').removeClass('search--active');
                    $(globalSearchWrapper).removeClass('search--list--active'); 
                    globalSearchResult.methods.resetSearch();
                }
            });
        },
        handleTags:function(){
            const {variables} = globalSearchResult;
            const {globalSearchPopularTags} = variables;
            const {CLICK} = CONSTANT.eventsListners;
            $(globalSearchPopularTags).on(CLICK, function(e){
                e.preventDefault();
                const $el = $(this);
                const searchText = $el.text().trim();
                $(variables.globalSearchInput).val(searchText);
                $(variables.globalSearchInput).trigger('input');
                // Keyboard users continue from the search box (results / Enter)
                $(variables.globalSearchInput).trigger('focus');
            });
        },
        handleOverlay:function(){
            const {CLICK} = CONSTANT.eventsListners;
            const {globalSearchButton,globalSearchWrapper,globalSearchActive} = globalSearchResult.variables;
            const $this = this;
            $('.header__backdrop').on(CLICK, function(e){
                $('.header__wrapper').removeClass('search--active');
                $(globalSearchWrapper).removeClass('search--list--active');
                $(globalSearchButton).find(globalSearchWrapper).removeClass(globalSearchActive.substr(1));
            });
        },
        closeSearch:function(){
            const {CLICK} = CONSTANT.eventsListners;
            const {globalSearchButton,globalSearchWrapper,globalSearchActive} = globalSearchResult.variables;
            const $this = this;
            $('.close-search').on(CLICK, function(e){
                $('.header__wrapper').removeClass('search--active');
                $(globalSearchWrapper).removeClass('search--list--active');
                $(globalSearchButton).find(globalSearchWrapper).removeClass(globalSearchActive.substr(1));
            });
            // svg[role=button]: activate with Enter/Space like a native button.
            $('.close-search').on('keydown', function(e){
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    $(this).trigger(CLICK);
                }
            });
        },
        viewAllClick:function(){
            const {CLICK} = CONSTANT.eventsListners;
            const {globalSearchForm} = globalSearchResult.variables;
            const $this = this;
            $('.global__search__viewall').on(CLICK, function(e){
                $this.submitSearchInput($(globalSearchForm))
            });
        },
        resetSearch:function(){
            const {globalSearchButton,globalSearchForm,globalSearchResultList,globalSearchPopularWrapper,globalSearchWrapper} = globalSearchResult.variables;
            $(globalSearchButton).find(globalSearchForm).get(0).reset();
            $(globalSearchResultList).html('');
            $(globalSearchButton).find(globalSearchResultList).addClass('d-none');
            $(globalSearchButton).find(globalSearchPopularWrapper).removeClass('d-none');
            $(globalSearchWrapper).removeClass('search--list--active');

        },
        searchViewAllClickedHandler: function(){
                $('.global__search__viewall').on('click', function()  {
                       let buttonName = $(this).text().replace(/\s+/g, ' ').trim();
                       let eventObj = { buttonText: buttonName };
                       let obj = globalSearchResult.methods.datalayerObj(eventObj, "Header Search");
                        createDataLayer('buttonClick', obj);
                     });
                },
        datalayerObj : function (e, el) {
            var obj = {
              'articleName' : "",
              'blogCategory' : "",
              'blogPageCategory' : "",
              'buttonText' : e.buttonText ? e.buttonText : "",
              'pageSection' : el ? el : "",
              'planOption' : "",
              'productCategory' : "",
              'productName' : "",
              'question' : "",
              'searchTerm' : e.searchTerm ? e.searchTerm : "",
              'videoTitle' : "",
              'bannerName' : "",
              'bannerType' : "",
              'leadForm' : "",
          }
          return obj;
        },
        // Keyboard and screen reader access (WCAG 2.1.1, 2.4.3, 2.4.7, 4.1.2):
        // the search icon is a button (Enter/Space opens the panel and moves
        // focus to the search field); while the panel is closed it is inert,
        // so its field and popular-search buttons are not invisible Tab stops;
        // closing it returns focus to the icon.
        keyboardAccess:function(){
            const {globalSearchButton,globalSearchWrapper,globalSearchActive,globalSearchInput} = globalSearchResult.variables;
            const activeClass = globalSearchActive.substr(1);
            $(globalSearchButton).each(function(){
                const button = this;
                const trigger = button.querySelector('.header__search--svg-find');
                const panel = button.querySelector(globalSearchWrapper);
                if (!trigger || !panel) {
                    return;
                }
                let openedByKeyboard = false;
                const sync = () => {
                    const open = panel.classList.contains(activeClass);
                    const hadFocus = panel.contains(document.activeElement);
                    panel.inert = !open;
                    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
                    if (open && openedByKeyboard) {
                        openedByKeyboard = false;
                        const input = panel.querySelector(globalSearchInput);
                        if (input) {
                            input.focus();
                        }
                    } else if (!open && hadFocus) {
                        trigger.focus();
                    }
                };
                new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class'] });
                sync();
                trigger.addEventListener('keydown', function(e){
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        openedByKeyboard = true;
                        $(trigger).trigger(CONSTANT.eventsListners.CLICK);
                    }
                });
            });
        },
        init:function(){
                globalSearchResult.methods.keyboardAccess();
                globalSearchResult.methods.openSearchBox();
                globalSearchResult.methods.submitSearchVal();
                globalSearchResult.methods.searchInputResult();
                globalSearchResult.methods.closeOnEsc();
                globalSearchResult.methods.searchSubmit();
                globalSearchResult.methods.handleOverlay();
                globalSearchResult.methods.handleTags();
                globalSearchResult.methods.closeSearch();
                globalSearchResult.methods.viewAllClick();
        }
    }
}

$(()=>{
    const {globalSearchButton} = globalSearchResult.variables
    if($(globalSearchButton).length){
    globalSearchResult.methods.init();
    globalSearchResult.methods.searchViewAllClickedHandler();
    }
})

export default globalSearchResult;